export enum OrganizationAttributeName {
    SKIP_AUTO_MIGRATION = 'SKIP_AUTO_MIGRATION',
    IP_ADDRESSES_IMPORTED = 'IP_ADDRESSES_IMPORTED'
}
